import { lazy } from 'react';

/**
 * 페이지 데이터 인터페이스
 */
export interface PageData {
    path: string;
    title: string;
    component: React.LazyExoticComponent<React.ComponentType<any>>;
    requireAuth: boolean;
    excludeLayout?: boolean;
}

/**
 * 페이지 데이터 객체
 */
export const PAGE_DATA: Record<string, PageData> = {
    dashBoard: {
        path: '/dashboard',
        title: '대시보드',
        component: lazy(() => import('@/pages/DashBoard')),
        requireAuth: true,
    },
    signup: {
        path: '/signup',
        title: '회원가입',
        component: lazy(() => import('@/pages/Signup')),
        excludeLayout: true,
        requireAuth: false,
    },
    login: {
        path: '/login',
        title: '로그인',
        component: lazy(() => import('@/pages/Login')),
        excludeLayout: true,
        requireAuth: false,
    },
    landing: {
        path: '/',
        title: '랜딩페이지',
        component: lazy(() => import('@/pages/Landing')),
        excludeLayout: true,
        requireAuth: false,
    },
    clientManagement: {
        path: '/clientmanagement',
        title: '클라이언트 관리',
        component: lazy(() => import('@/pages/ClientManagement')),
        excludeLayout: true,
        requireAuth: true
    },
    userProfile: {
        path: '/:userId',
        title: '워크스페이스 - 개요',
        component: lazy(() => import('@/pages/Workspace/Overview')),
        requireAuth: true
    },
    overview: {
        path: '/:userId/overview',
        title: '워크스페이스 - 개요',
        component: lazy(() => import('@/pages/Workspace/Overview')),
        requireAuth: true
    },
    companyManagement: {
        path: '/:userId/company-management',
        title: '워크스페이스 - 회사관리',
        component: lazy(() => import('@/pages/Workspace/CompanyManagement')),
        requireAuth: true
    },
    accountingManagement: {
        path: '/:userId/accountingmanagement',
        title: '워크스페이스 - 회계관리',
        component: lazy(() => import('@/pages/Workspace/AccountingManagement')),
        requireAuth: true
    },
    collectionManagement: {
        path: '/:userId/collection-management',
        title: '워크스페이스 - 수집정보관리',
        component: lazy(() => import('@/pages/Workspace/DataCollectionManagement')),
        requireAuth: true
    }
};